import React from 'react'

export const SkillSet = [
    {
        "title": "HTML",
        "image": "assets/skill/html.png"
    },

    {
        "title": "CSS",
        "image": "assets/skill/css.png"
    },

    {
        "title": "javaScript",
        "image": "assets/skill/javascript.png"
    },

    {
        "title": "React",
        "image": "assets/skill/react.png"
    },

    {
        "title": "Testing and Debuggind",
        "image": "assets/skill/testdebug.png"
    },

    {
        "title": "Responsive Web Design",
        "image": "assets/skill/responsive.png"
    },

    {
        "title": "Cross-browser development",
        "image": "assets/skill/crossbrowserdev.png"
    },

    {
        "title": "Accessibility",
        "image": "assets/skill/access.png"
    },

    {
        "title": "Canva Design",
        "image": "assets/skill/canva.svg"
    },

    {
        "title": "Version Control",
        "image": "assets/skill/git.png"
    },

    {
        "title": "Bootstrap",
        "image": "assets/skill/bootstrap.png"
    },

    {
        "title": "Sass",
        "image": "assets/skill/sass.png"
    },

    {
        "title": "Testing and Debugging",
        "image": "assets/skill/testdebug.png"
    },


    {
        "title": "Communication",
        "image": "assets/skill/communication.png"
    },

    {
        "title": "Creativity",
        "image": "assets/skill/creativ.png"
    },



]

export const Tools = [
    {
        "title": "Vs Code",
        "image": "assets/skill/vscode.png"
    },

    {
        "title": "ReactJs",
        "image": "assets/skill/react.png"
    },

    {
        "title": "git",
        "image": "assets/skill/git.png"
    },

    {
        "title": "Github",
        "image": "assets/skill/github.png"
    },

    {
        "title": "Vercel",
        "image": "assets/skill/vercel.png"
    },

    {
        "title": "Canva",
        "image": "assets/skill/canva.svg"
    },

]

export const Projects = [
    {
        "title": "ZeeCode Academy",
        "image": "assets/project/zeecode.png",
        "desc": "Zeecode Academy offers interactive frontend development courses, covering HTML, CSS, JavaScript, and more.",
        "skills": ["ReactJs", "RestAPI", "Sass"],
        "demo": "https://zeecode.vercel.app/",
        "source": "https://github.com/IdrisFirdaws/ZeeCode",
        "type": "webapp"
    },

    {
        "title": "GFS-Dashboard",
        "image": "assets/project/gfs.png",
        "desc": "This is a dashboard prototype for a logistic company",
        "skills": ["ReactJs", "Sass"],
        "demo": "https://gfs-frontends.vercel.app/dashboard",
        "source": "",
        "type": "dashboard"
    },

    {
        "title": "AfriRecipes",
        "image": "assets/project/afri-recipe.png",
        "desc": "A webApp providing users with recipe search and meal planning features for easy and convenient meal preparation.",
        "skills": ["ReactJs", "RestAPI", "Sass"],
        "demo": "https://afri-recipes.vercel.app/",
        "source": "https://github.com/IdrisFirdaws/AfriRecipes",
        "type": "webapp"
    },
    {
        "title": "ENNYEN Marketplace",
        "image": "assets/project/ennyen.png",
        "desc": "This is a alnding page for a solar product distribution company",
        "skills": ["ReactJs", "Sass"],
        "demo": "https://ennyen-marketplace-frontend.vercel.app/",
        "source": "",
        "type": "landing"
    },
    {
        "title": "Zee's Kitchen",
        "image": "assets/project/zs-kitchen.png",
        "desc": "A restaurant booking website facilitating reservations and dining experiences at various eateries for users' convenience.",
        "skills": ["HTML", "CSS", "JavaScript"],
        "demo": "https://zs-kitchen.vercel.app/",
        "source": "https://github.com/IdrisFirdaws/Zees-Kitchenn",
        "type": "landing"
    },

    {
        "title": "Support Cycle",
        "image": "assets/project/support-cycle.png",
        "desc": "NGO empowering rural entrepreneurs with grants, resources. Driving economic growth in West Africa.",
        "skills": ["HTML", "JavaScript", "Sass"],
        "demo": "https://support-cycle.web.app/",
        "source": "https://github.com/IdrisFirdaws/support-cycle",
        "type": "landing"
    },
    {
        "title": "VVIMS Dashboard",
        "image": "assets/project/vvims.png",
        "desc": "A dashboard prototype for a vehicle enrty and maintainance company",
        "skills": ["React", "Sass"],
        "demo": "https://dashboard-vvim.vercel.app/",
        "source": "",
        'type': "dashboard"
    },
    {
        "title": "LangTrans",
        "image": "assets/project/lang-trans.png",
        "desc": "A one-page portfolio app for a video translator, translated into 10 languages using i18n for accessibitly",
        "skills": ["ReactJs", 'i18n', "Sass"],
        "demo": "https://https://langtrans.vercel.app/",
        "source": "https://github.com/IdrisFirdaws/AfriRecipes",
        "type": "landing"
    },
    {
        "title": "Zhomes",
        "image": "assets/project/zhomes.png",
        "desc": "A real estate website showcasing property listings and facilitating easy transactions for buyers, sellers, and renters.",
        "skills": ["HTML", "Bootstrap", "JavaScript",],
        "demo": "https://zhomes.vercel.app/",
        "source": "https://github.com/IdrisFirdaws/ZHomes",
        "type": "landing"
    },
    {
        "title": "Dooddle",
        "image": "assets/project/dooddle.png",
        "desc": "A playful web canvas for toddlers to unleash creativity with colorful drawings and easy mouse/touch doodles.",
        "skills": ["HTML", "CSS", "JavaScript",],
        "demo": "https://dooddle.vercel.app/",
        "source": "https://github.com/IdrisFirdaws/dooddles",
        "type": 'webapp'
    },
    // {
    //     "title": "Zee's Shop",
    //     "image": "assets/project/zees-shop.png",
    //     "desc": "An online shopping website providing a user-friendly interface for browsing, selecting, and purchasing products online.",
    //     "skills": ["HTML", "CSS", "JavaScript"],
    //     "demo": "https://zees-shop.vercel.app/",
    //     "source": "https://github.com/IdrisFirdaws/Zees-Shop"
    // }
]

export default function Data() {

    return (
        <div>

        </div>
    )
}


